import { Row, Card, Typography, message } from "antd";
import { useParams } from "react-router-dom";
import { lazy, Suspense, useEffect, useState } from "react";
import GETDetalleOrdenREU from "../../../helpers/ordenes/GETDetalleOrdenREU";
import { ScanOutlined, SyncOutlined } from "@ant-design/icons";
import PUTIniciarOrden from "../../../helpers/ordenes/PUTIniciarOrden";
import PUTPausarOrden from "../../../helpers/ordenes/PUTPausarOrden";
import { accionConfig } from "../../../utils/getAccionConfig";
import HeaderBack from "../../../components/layout/headers/HeaderBack";
import AppLayout from "../../../components/layout/AppLayout";
import Loader from "../../../components/loader/Loader";
import RenderREU from "./RenderREU";
import { useAuth } from "../../../AuthContext";

const { Text } = Typography;

const ModalTecladoAlfanumerico = lazy(
  () =>
    import("../../../components/modalTecladoAlfanumerico/ModalTecladoAlfanumerico"),
);

const DetalleReubicacion = ({ darkMode, setDarkMode }) => {
  const { idomam } = useParams();
  const { loggedUser } = useAuth();
  const [orden, setOrden] = useState(null);
  const [loading, setLoading] = useState(true);
  const [procesandoAccion, setProcesandoAccion] = useState(false);
  const [tecladoVisible, setTecladoVisible] = useState(false);
  //  Estados para compartir el valor del teclado con los hijos
  const [valorTecladoGlobal, setValorTecladoGlobal] = useState(null);

  const accionActual = orden ? accionConfig[orden.estadoOpe] || null : null;

  const ordenActiva = orden ? orden.estadoOpe === "2" : false;

  const manejarConfirmacionTeclado = (valor) => {
    setValorTecladoGlobal(valor);

    // Limpiar después de un tick para que los hijos lo capturen
    setTimeout(() => {
      setValorTecladoGlobal(null);
    }, 0);

    setTecladoVisible(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      if (!idomam || !loggedUser) {
        setOrden(null);
        return;
      }

      try {
        setLoading(true);
        const response = await GETDetalleOrdenREU(idomam);

        if (response?.status >= 200 && response.status < 300 && response.data) {
          setOrden(response.data);
        } else {
          setOrden(null);
        }
      } catch {
        message.error("No se pudo cargar la información de la orden.");
        setOrden(null);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [idomam, loggedUser]);

  const handleAccion = async () => {
    if (procesandoAccion) return;
    if (!orden || !loggedUser) return;
    const accion = accionConfig[orden.estadoOpe];
    if (!accion) return;

    setProcesandoAccion(true);
    try {
      const response =
        orden.estadoOpe === "1"
          ? await PUTIniciarOrden(orden.idOpe)
          : await PUTPausarOrden(orden.idOpe, accion.accion);

      if (response?.status === 200) {
        const nuevoEstado = accion.accion ? "4" : "2";
        setOrden((prev) => ({ ...prev, estadoOpe: nuevoEstado }));
        // message.success(response.data?.descri || "Estado actualizado.");
      } else {
        message.error(
          response?.data?.message ||
            "No se pudo cambiar el estado de la orden.",
        );
      }
    } catch {
      message.error("Error al procesar la acción.");
    } finally {
      setProcesandoAccion(false);
    }
  };

  const headerComponent = (
    <HeaderBack
      modulo={"Mis Reubicaciones"}
      data={{ headerTitle: orden?.comprobanteOMA }}
      acciones={
        <div style={{ display: "flex", gap: 12 }}>
          {ordenActiva && (
            <span
              onClick={() => {
                setTecladoVisible(true);
              }}
              style={{ cursor: "pointer", display: "flex" }}
            >
              <ScanOutlined
                className="custom-icon"
                style={{ fontSize: "36px", color: "white" }}
              />
            </span>
          )}

          <span
            onClick={handleAccion}
            style={{
              cursor: procesandoAccion ? "default" : "pointer",
              display: "flex",
              pointerEvents: procesandoAccion ? "none" : "auto",
              opacity: procesandoAccion ? 0.6 : 1,
            }}
          >
            {procesandoAccion ? (
              <SyncOutlined spin style={{ fontSize: "36px", color: "white" }} />
            ) : (
              accionActual?.icon
            )}
          </span>
        </div>
      }
    />
  );

  return (
    <AppLayout
      darkMode={darkMode}
      setDarkMode={setDarkMode}
      header={headerComponent}
    >
      <div
        style={{
          height: "100%",
          padding: "8px",
          overflowY: "auto",
          overflowX: "hidden",
        }}
      >
        {loading && <Loader />}
        {!loading && orden && (
          <Row gutter={[8, 8]} justify="start" align="stretch">
            <RenderREU
              dataOrden={orden}
              darkMode={darkMode}
              ordenActiva={ordenActiva}
              valorTecladoGlobal={valorTecladoGlobal}
            />
          </Row>
        )}
        {!loading && !orden && (
          <Card
            style={{
              textAlign: "center",
              backgroundColor: darkMode ? "#1f1f1f" : "#fafafa",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "32px",
            }}
          >
            <Text type="secondary" style={{ fontSize: "19px" }}>
              Detalle de reubicación no encontrada.
            </Text>
          </Card>
        )}
      </div>

      {tecladoVisible && (
        <Suspense fallback={null}>
          <ModalTecladoAlfanumerico
            open={tecladoVisible}
            onClose={() => {
              setTecladoVisible(false);
            }}
            darkMode={darkMode}
            letras={["A", "B", "C", "J", "P", "#"]} // OTERO
            // letras={["A", "B", "C", "D", "P", "#"]} // OTROS
            onConfirm={manejarConfirmacionTeclado}
            title="Ingrese ubicación o código"
          />
        </Suspense>
      )}
    </AppLayout>
  );
};

export default DetalleReubicacion;
